import { Navigate } from 'react-router'
import { useAuth } from '~/api/auth'

const RequireAuth = (props) => {
  const { children } = props
  const { loginURL, render } = useAuth()
  return render(children, <Navigate to={loginURL} replace />)
}

export default RequireAuth
